import React, { memo } from 'react'
import { string } from 'prop-types'
import classNames from 'src/common/helpers/class-names'
import kebab from 'lodash/kebabCase'

import formatMeatSticker from './linksave-config'

const shouldUseFallback = (promoOfferTypeCode, promoQty, promoValue) => {
  const CODE = promoOfferTypeCode ? Number(promoOfferTypeCode) : ''
  switch (CODE) {
    case 8:
      return false
    case 13:
      return false
    case 15: {
      return !(promoQty && promoValue)
    }
    default:
      return true
  }
}

const MeatSticker = ({
  promoQty,
  promoValue,
  promoOfferTypeCode,
  mix,
  baseName,
}) => {
  const elt = 'meat-sticker'
  if (!shouldUseFallback(promoOfferTypeCode, promoQty, promoValue)) {
    const formatContents = formatMeatSticker(
      Number(promoOfferTypeCode),
      promoQty,
      promoValue,
    )
    return (
      <div className={classNames({ blk: baseName, elt })}>
        {formatContents.map((linksave, index) => {
          const key = kebab(`${linksave.content}-${index}`)
          const configClassName = classNames({
            blk: baseName,
            elt: 'config',
            mods: linksave.mods,
            mix,
          })
          return (
            <span className={configClassName} key={key}>
              {linksave.content}
            </span>
          )
        })}
        <span className={classNames({ blk: baseName, elt: 'view-all', mix })}>
          View all
        </span>
      </div>
    )
  }

  return (
    <div className={classNames({ blk: baseName, elt, mix })}>
      <span className={classNames({ blk: baseName, elt: 'quantity', mix })}>
        {`${promoQty} for `}
      </span>
      <span className={classNames({ blk: baseName, elt: 'price', mix })}>
        {promoValue}
      </span>
      <span className={classNames({ blk: baseName, elt: 'view-all', mix })}>
        View all
      </span>
    </div>
  )
}

MeatSticker.propTypes = {
  mix: string,
  promoOfferTypeCode: string,
  promoQty: string,
  promoValue: string,
  baseName: string,
}

MeatSticker.defaultProps = {
  mix: '',
  promoOfferTypeCode: '',
  promoQty: '',
  promoValue: '',
  baseName: '',
}

export default memo(MeatSticker)



// WEBPACK FOOTER //
// ./shared/interim/product/link-save-primary-banner/meat-sticker.js